import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {EmailModalComponent} from '../modal/email-modal/email-modal.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Rutas} from '../../utiles/Rutas';
import {Router} from '@angular/router';
import {FirmaComponent} from '../modal/firma/firma.component';
import Swal from 'sweetalert2';
import {ExpedientesService} from './expedientes.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalInjectorService {

  private colaborador;
  private formData: FormData;
  provincia: any;

  constructor(public dialog: MatDialog, private snackbar: MatSnackBar, private http: HttpClient, private router: Router,
              private expService: ExpedientesService) {
    this.colaborador = sessionStorage.getItem('colaborador');
  }

  openEmailDialog(email: string, nombre: string, id): void {
    console.log(email);
    if ( email !== ''){
      const dialogRef = this.dialog.open(EmailModalComponent, {width: '250px'});
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          if (email === '') {
            this.snackbar.open('Debe introducir una direccion de correo electrónico, por favor, revise los datos.', 'OK', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: 'snack-cliente'
            });
            this.router.navigate(['page/solicitudes']);
            return;
          }

          this.expService.sendFilesEmailCliente(id, nombre, true, email).subscribe( res => {

            this.snackbar.open('Email enviado correctamente', '', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: 'snack-cliente-ok',
              duration: 5000
            });
            this.router.navigate(['page/solicitudes']);
          }, (error) => {
            console.log(error);
            this.snackbar.open('No se ha podiodo enviar el email, revise los datos.', 'OK', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: 'snack-cliente'
            });
          });
        } else {
          this.router.navigate(['page/solicitudes']);
        }
      });
    }
    this.router.navigate(['page/solicitudes']);


  }



  OpenFirmaDiag(Cliente: any, tipo: string, id, tipoFirma: any): any {
    if (Cliente.telefono !== ''){
      const dialogRef2 = this.dialog.open(FirmaComponent, {
        width: '250px',
        hasBackdrop: true,
        panelClass: 'custom-dialog'
      });
      dialogRef2.afterClosed().subscribe(data => {
        if (data !== undefined) {
          if (data === '0') {

            this.openEmailDialog(Cliente.email, Cliente.nombre, id);
          }
          if (data === '1') {
            if (tipo === '1' || tipo === '3') {
              let mb = '';
              if (Cliente.matricula === undefined || Cliente.matricula === null) {
                mb = Cliente.bastidor;
              } else {
                mb = Cliente.matricula;
              }
              const datum = {
                matricula_mandato: mb,
                nombre_mandante: Cliente.nombre,
                apellidos_mandante: Cliente.apellido1 + ' ' + Cliente.apellido2,
                nif_mandante: Cliente.nif,
                telefono_mandante: Cliente.telefono,
                email_mandante: Cliente.email,
                nombre_mandante2: '',
                apellidos_mandante2: '',
                nif_mandante2: '',
                telefono_mandante2: '',
                email_mandante2: '',
                doi_representado: '',
                nombre_representado: '',
                provincia: Cliente.provincia,
                ine_municipio: Cliente.poblacion,
                cp: Cliente.cp,
                nombre_calle: Cliente.direccion,
                num_calle: Cliente.direccionnumero,
                id,
                tipo: 'solicitud',
                tipoFirma,
              };
              console.log(datum, 'v o i');
              this.formData = new FormData();
              Object.keys(datum).forEach(key => this.formData.append(key, datum[key]));
              this.sendFirma(this.formData).subscribe((res) => {
                console.log(res);
                if (res.result === 'ok'){
                  this.snackbar.open('Mensaje sms enviado correctamente', '', {
                    horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente-ok', duration: 5000
                  });
                  // this.openEmailDialog(Cliente.email, Cliente.nombre, id);
                }
                if (res.result === 'error') {
                  this.snackbar.open(res.message , 'OK', {
                    horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente', duration: 8000
                  });
                  console.log('tipo', Cliente.tipo);
                  // this.openEmailDialog(Cliente.email, Cliente.nombre, id);

                }
              }, (error) => {
                console.log(error);
                this.snackbar.open('No se ha podiodo enviar el mensaje sms, revise los datos.', 'OK', {
                  horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente', duration: 5000
                });
                this.openEmailDialog(Cliente.email, Cliente.nombre, id);
              });
            }
            if (tipo === '2' || tipo === '3') {
              const datum = {
                matricula_mandato: Cliente.matricula === undefined ? Cliente.bastidor : Cliente.matricula,
                nombre_mandante: Cliente.nombreVendedor,
                apellidos_mandante: Cliente.apellido1Vendedor + ' ' + Cliente.apellido2Vendedor,
                nif_mandante: Cliente.nifVendedor,
                telefono_mandante: Cliente.telefonoVendedor,
                email_mandante: Cliente.emailVendedor,
                nombre_mandante2: '',
                apellidos_mandante2: '',
                nif_mandante2: '',
                telefono_mandante2: '',
                email_mandante2: '',
                doi_representado: '',
                nombre_representado: '',
                provincia: Cliente.provinciaVendedor,
                ine_municipio: Cliente.poblacionVendedor,
                cp: Cliente.cpVendedor,
                nombre_calle: Cliente.direccionVendedor,
                num_calle: Cliente.direccionnumeroVendedor,
                id,
                tipo: 'solicitud',
                tipoFirma
              };
              console.log(datum, 'c o i');
              this.formData = new FormData();
              Object.keys(datum).forEach(key => this.formData.append(key, datum[key]));
              this.sendFirma(this.formData).subscribe((res) => {
                console.log(res);
                if (res.result === 'ok'){
                  this.snackbar.open('Mensaje sms enviado correctamente', '', {
                    horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente-ok', duration: 5000
                  });
                  this.openEmailDialog(Cliente.email, Cliente.nombre, id);
                }
                if (res.result === 'error') {
                  this.snackbar.open(res.message + ', en los campos ' + res.errors.join(', '), 'OK', {
                    horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente', duration: 8000
                  });
                  this.openEmailDialog(Cliente.email, Cliente.nombre, id);
                }
              }, (error) => {
                console.log(error);
                this.snackbar.open('No se ha podiodo enviar el mensaje sms', 'OK', {
                  horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente', duration: 5000
                });
                this.openEmailDialog(Cliente.email, Cliente.nombre, id);
              });
            }
          }
        } else {
          this.openEmailDialog(Cliente.email, Cliente.nombre, id);
        }
      });
    }
    console.log(Cliente);
    this.openEmailDialog(Cliente.email, Cliente.nombre, id);
  }

  sendFirma(datos): any {
    return this.http.post(Rutas + 'post_sigafirma', datos);
  }

  checkSMSClienteComprador(solicitud: any): boolean{
    let result = false;
    if ( solicitud.telefono &&
      solicitud.email && solicitud.provincia &&
      solicitud.poblacion && solicitud.cp && solicitud.direccion &&
      solicitud.direccionnumero && (solicitud.matricula || solicitud.bastidor) &&
     solicitud.baseImponible && solicitud.marca) {
      result = true;
    }
    else {
      return result;
    }
    // Cliente
    if ( solicitud.sexo === 'EMPRESA'){
      if (solicitud.apellido1 && solicitud.nif && solicitud.nifApoderado && solicitud.nombreApoderado && solicitud.apellido1Apoderado){
        return result;
      }
      else {
        return false;
      }
    }
    else {
      if ( solicitud.nif && solicitud.nombre && solicitud.apellido1){
          return result;
        }else{
        return false;
      }
    }
  }

  checkSMSClienteVendedor(solicitud: any): boolean{
    console.log("Vendedor", solicitud);
    let result = false;
    if ( solicitud.telefonoVendedor &&
      solicitud.emailVendedor && solicitud.provinciaVendedor &&
      solicitud.poblacionVendedor && solicitud.cp && solicitud.direccionVendedor &&
      solicitud.direccionnumeroVendedor && (solicitud.matricula || solicitud.bastidor) &&
      solicitud.baseImponible && solicitud.marca){
        console.log("Entro en el 1 if");
        result = true;
    }
    else {
      console.log("Entro en el 1 else");
      return result;
    }
    // Cliente
    if ( solicitud.sexoVendedor === 'EMPRESA'){
      if (solicitud.apellido1Vendedor && solicitud.nifVendedor && solicitud.nifApoderadoVendedor &&
        solicitud.nombreApoderadoVendedor && solicitud.apellido1ApoderadoVendedor){
        console.log("Entro en el 2 if");
        return result;
      }
      else {
        console.log("Entro en el 2 else");
        return false;
      }
    }
    else {
      if ( solicitud.nifVendedor && solicitud.nombreVendedor && solicitud.apellido1Vendedor){
        console.log("Entro en el 3 if");
        return result;
      }else{
        console.log("Entro en el 3 else");
        return false;
      }
    }
  }
  
  checkSMS(solicitud: any): boolean{
    let result = false;
    if ( solicitud.telefono &&
      solicitud.email && solicitud.provincia &&
      solicitud.poblacion && solicitud.cp && solicitud.direccion &&
      solicitud.direccionnumero && (solicitud.matricula || solicitud.bastidor)){
      result = true;
    }
    else {
      return result;
    }
    // Cliente
    if ( solicitud.sexo === 'X'){
      if (solicitud.apellido1 && solicitud.nif && solicitud.nifApoderado && solicitud.nombreApoderado && solicitud.apellido1Apoderado){
        return result;
      }
      else {
        return false;
      }
    }
    else {
      if ( solicitud.nif && solicitud.nombre && solicitud.apellido1){
        return result;
      }else{
        return false;
      }
    }
  }

  enviarSMS(Cliente): void {
    const dialogRef2 = this.dialog.open(FirmaComponent, {
      width: '250px',
      hasBackdrop: true,
      panelClass: 'custom-dialog'
    });
    dialogRef2.afterClosed().subscribe(data => {
      if (data !== undefined) {
        if (data === '1') {
          let tipo = '';
          switch (Cliente.Tramite){
            case Cliente.Tramite.toLowerCase().includes('baja'):
              tipo = '2';
              break;
            case Cliente.Tramite.toLowerCase().includes('matricula'):
              tipo = '1';
              break;
            case Cliente.Tramite.toLowerCase().includes('cambio') || Cliente.Tramite.toLowerCase().includes('doble'):
              tipo = '3';
              break;
          }

          let mb = '';
          if (Cliente.matricula === undefined || Cliente.matricula === null) {
            mb = Cliente.bastidor;
          } else {
            mb = Cliente.matricula;
          }
          const datum = {
            matricula_mandato: mb,
            nombre_mandante: Cliente.nombre,
            apellidos_mandante: Cliente.apellido1 + ' ' + Cliente.apellido2,
            nif_mandante: Cliente.nif,
            telefono_mandante: Cliente.telefono,
            email_mandante: Cliente.email,
            nombre_mandante2: '',
            apellidos_mandante2: '',
            nif_mandante2: '',
            telefono_mandante2: '',
            email_mandante2: '',
            doi_representado: '',
            nombre_representado: '',
            provincia: Cliente.provincia,
            ine_municipio: Cliente.poblacion,
            cp: Cliente.cp,
            nombre_calle: Cliente.direccion,
            num_calle: Cliente.direccionnumero,
            id: Cliente.id,
            tipo: 'EXPEDIENTE',
            tipoFirma: tipo
          };
          console.log(datum, 'v o i');
          this.formData = new FormData();
          Object.keys(datum).forEach(key => this.formData.append(key, datum[key]));
          this.sendFirma(this.formData).subscribe((res) => {
            console.log(res);
            if (res.result === 'ok'){
              this.snackbar.open('Mensaje sms enviado correctamente', '', {
                horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente-ok', duration: 5000
              });



            }
            if (res.result === 'error') {
              this.snackbar.open(res.message , 'OK', {
                horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente', duration: 8000
              });
              console.log('tipo', Cliente.tipo);

            }
          }, (error) => {
            console.log(error);
            this.snackbar.open('No se ha podiodo enviar el mensaje sms, revise los datos.', 'OK', {
              horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snack-cliente', duration: 5000
            });

          });
        }

      }

    });
  }

  enviarSMSViaFirma(datum): Observable<any>{
    return this.sendFirma(datum);
  }

  checkDataMatriculacion(solicitud: any): boolean{
    console.log("Solicitud", solicitud);
    let result = false;
    if ( solicitud.telefono &&
      solicitud.email && solicitud.provincia &&
      solicitud.poblacion && solicitud.cp && solicitud.direccion &&
      solicitud.direccionnumero && (solicitud.matricula || solicitud.bastidor)){
        console.log("Entro en if");
      result = true;
    }
    else {
      console.log("Entro en else");
      return result;
      console.log('1');
    }
    // Cliente
    if (solicitud.sexo === 'EMPRESA') { 
      if (solicitud.apellido1 && solicitud.nif && solicitud.nifApoderado && solicitud.nombreApoderado && solicitud.apellido1Apoderado){
        console.log("Entro en el if de empresa");
        return result;
      }
      else {
        console.log("Entro en el else de empresa");
        return false;
        console.log('2');
      }
    }
    else {
      if ( solicitud.nif && solicitud.nombre && solicitud.apellido1){
        return result;
      }else{
        return false;
        console.log('3');
      }
    }
  }
}
